<template>
    <section class="terms col-12">
        <div style="text-align: center">
            <img
                src="https://app.planejadordetreino.com/images/logo.jpg"
                style="width: 90%"
            />
            <h1 class="py-4">Política de Privacidade</h1>
        </div>

        <p>
            A presente Política de Privacidade descreve como o Planejador de
            Treino coleta, utiliza, armazena e protege os dados pessoais dos
            usuários que utilizam a plataforma disponível em
            <strong>planejadordetreino.com</strong>.
        </p>

        <h4>1. Informações coletadas</h4>

        <p>
            Durante a utilização da plataforma, podemos coletar as seguintes
            informações:
        </p>

        <h3>1.1 Dados de cadastro</h3>
        <ul>
            <li>Nome</li>
            <li>E-mail</li>
            <li>Senha (armazenada de forma criptografada)</li>
            <li>Número de telefone (utilizado apenas para suporte)</li>
        </ul>

        <h3>1.2 Dados criados pelo usuário</h3>
        <p>
            Durante o uso do Planejador de Treino, o usuário pode inserir dados
            como:
        </p>
        <ul>
            <li>Nomes de clubes</li>
            <li>Nomes de jogadores</li>
            <li>Treinos, exercícios, PDFs, vídeos e conteúdos similares</li>
        </ul>
        <p>
            Esses dados não são obrigatórios e são fornecidos de forma
            voluntária.
        </p>

        <h4>2. Uso de cookies e armazenamento local</h4>
        <p>
            O Planejador de Treino não utiliza cookies de rastreamento
            publicitário. Algumas informações podem ser armazenadas localmente
            no navegador (localStorage) para garantir o correto funcionamento da
            plataforma e coletar estatísticas internas de uso.
        </p>

        <h4>3. Uso das informações</h4>
        <p>Os dados coletados são utilizados para:</p>
        <ul>
            <li>Permitir o acesso e funcionamento da plataforma</li>
            <li>Melhorar a qualidade dos serviços oferecidos</li>
            <li>Fornecer suporte técnico ao usuário</li>
            <li>
                Desenvolver novas funcionalidades, incluindo recursos baseados
                em Inteligência Artificial
            </li>
        </ul>

        <h4>4. Compartilhamento de dados</h4>
        <p>
            Os dados de cadastro dos usuários são privados e acessados apenas
            pelo próprio usuário e pela equipe do Planejador de Treino,
            exclusivamente para fins de suporte e melhoria do serviço.
        </p>

        <p>
            Os dados criados na plataforma (como treinos, exercícios e exemplos
            de conteúdo) podem ser compartilhados com terceiros dentro de
            ambientes controlados e fechados, exclusivamente para:
        </p>
        <ul>
            <li>Treinamento de modelos de Inteligência Artificial</li>
            <li>Fornecimento de novos serviços e funcionalidades</li>
        </ul>

        <p>
            Como exemplo, alguns dados podem ser enviados a serviços de IA, como
            a OpenAI, sempre respeitando boas práticas de segurança.
        </p>

        <h4>5. Armazenamento dos dados</h4>
        <p>
            Atualmente, a plataforma é hospedada em servidores VPS da HostGator.
            Conforme a demanda, a infraestrutura poderá migrar para provedores
            como AWS ou Google Cloud.
        </p>

        <p>Não possuímos, no momento, infraestrutura própria de servidores.</p>

        <h4>6. Retenção e exclusão de dados</h4>
        <p>
            Os dados dos usuários são mantidos enquanto a conta estiver ativa.
            Contas inativas por um período superior a 2 (dois) anos podem ser
            removidas, juntamente com os dados associados.
        </p>

        <p>
            Dados previamente coletados para treinamento de Inteligência
            Artificial não são necessariamente apagados junto com contas
            inativas, podendo permanecer como cópias anonimizadas de treinos e
            exercícios.
        </p>

        <p>O usuário pode, a qualquer momento:</p>
        <ul>
            <li>Excluir sua conta diretamente</li>
            <li>Solicitar a remoção total ou parcial de seus dados</li>
        </ul>

        <h4>7. Segurança</h4>
        <p>
            As senhas são armazenadas de forma criptografada. Não realizamos
            envio de e-mails automáticos de spam e adotamos medidas técnicas
            razoáveis para proteger os dados armazenados.
        </p>

        <h4>8. Contato</h4>
        <p>
            Para dúvidas, solicitações ou questões relacionadas à privacidade e
            proteção de dados, o usuário pode entrar em contato através de:
        </p>

        <ul>
            <li>E-mail: paulo_junior.95@hotmail.com</li>
            <li>
                WhatsApp:
                <a href="https://api.whatsapp.com/message/567MNUG3EA6JA1"
                    >https://api.whatsapp.com/message/567MNUG3EA6JA1</a
                >
            </li>
        </ul>

        <p>
            Esta Política de Privacidade pode ser atualizada periodicamente. A
            versão mais recente estará sempre disponível na plataforma.
        </p>

        <div class="pa-4 bg-white">
            <p style="text-align: center">
                PAULO HENRIQUE MARQUES JUNIOR<br />CNPJ: 37.051.662/0001-09<br />JOINVILLE
                – SC<br />EMAIL: paulo_junior.95@hotmail.com
            </p>
        </div>
    </section>
</template>

<script>
export default {
    name: "PolicyView",
    created() {
        document.body.classList.add("login-page");
        document.title = "Políticas de privacidade - planejador de treinos";
    },
};
</script>

<style scoped lang="scss">
section {
    h1,
    h4 {
        font-weight: bolder;
    }
}
</style>
